module.exports = __webpack_public_path__ + "img/darall_invert.de388a00.png";